import React from 'react';

function TrustIcon({ children }) {
  return (
    <div className="checkout-trust-badge-icon">
      {children}
    </div>
  );
}

export function CheckoutTrustBadges({ labels }) {
  return (
    <div className="checkout-trust-badges">
      <div className="checkout-trust-badge">
        <TrustIcon>
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path
              fill="currentColor"
              d="M12 2L4 5v6c0 5 3.5 9.1 8 10 4.5-.9 8-5 8-10V5l-8-3zm0 2.2l5 2v4.8c0 3.7-2.4 7-5 7.8-2.6-.8-5-4.1-5-7.8V6.2l5-2zm-1 9.8l-2.5-2.5 1.4-1.4L11 11.2l3.1-3.1 1.4 1.4L11 14z"
            />
          </svg>
        </TrustIcon>
        <span>{labels.secure}</span>
      </div>
      <div className="checkout-trust-badge">
        <TrustIcon>
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path
              fill="currentColor"
              d="M12 2a4 4 0 00-4 4v3H6a2 2 0 00-2 2v7a2 2 0 002 2h12a2 2 0 002-2v-7a2 2 0 00-2-2h-2V6a4 4 0 00-4-4zm-2 4a2 2 0 114 0v3h-4V6zm2 6a1.75 1.75 0 00-.75 3.34V17h1.5v-1.66A1.75 1.75 0 0012 12z"
            />
          </svg>
        </TrustIcon>
        <span>{labels.encrypted}</span>
      </div>
      <div className="checkout-trust-badge">
        <TrustIcon>
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path
              fill="currentColor"
              d="M4 5h16c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2zm0 2v2h16V7H4zm0 4v6h16v-6H4zm2 3h4v2H6v-2z"
            />
          </svg>
        </TrustIcon>
        <span>{labels.pciDss}</span>
      </div>
    </div>
  );
}

export function CheckoutSecureBanner() {
  return (
    <div className="checkout-secure-banner">
      <div className="checkout-secure-banner-icon">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path
            fill="currentColor"
            d="M12 2L4.5 5v6.75C4.5 16.76 7.59 20.4 12 22c4.41-1.6 7.5-5.24 7.5-10.25V5L12 2zm0 2.18l5.5 2.2v5.37c0 3.31-2.13 6.32-5.5 7.67-3.37-1.35-5.5-4.36-5.5-7.67V6.38L12 4.18zM9.75 11.5L8.5 12.75 11 15.25l4.5-4.5-1.25-1.25L11 12.75l-1.25-1.25z"
          />
        </svg>
      </div>
      <div>
        <div className="checkout-secure-banner-title">Secure &amp; Encrypted</div>
        <div className="checkout-secure-banner-text">
          Your payment information is protected.
        </div>
      </div>
    </div>
  );
}
